/**
 * What to call an entity on screen, rather than the logical name the API speaks. Known
 * names are listed; anything else is prettified from its logical name.
 */
const EntityDisplayNames: Record<string, string> = {
  account: "Accounts",
  contact: "Contacts",
  customeraddress: "Addresses",
  invoice: "Invoices",
  listmember: "Marketing List Memberships",
  g4c_communicationactivity: "Communication Activities",
  g4c_communicationaudit: "Communication Audits",
  g4gdpr_contactaudit: "Contact Audits",
  g4gdpr_subscriptionaudit: "Subscription Audits",
};

const PublisherPrefix = /^(g4c_|g4gdpr_|g4ca_|g4_|new_)/;

function prettify(entityName: string) {
  const withoutPrefix = entityName.replace(PublisherPrefix, "");

  return withoutPrefix.charAt(0).toUpperCase() + withoutPrefix.slice(1);
}

export function getEntityDisplayName(entityName: string) {
  if (!entityName) {
    return "";
  }

  return EntityDisplayNames[entityName.toLowerCase()] ?? prettify(entityName);
}
